import React, { StrictMode } from 'react'
import { BrowserRouter } from 'react-router-dom'

import AuthContext from 'client/contexts/AuthContext'
import { MenuProvider } from 'client/contexts/MenuContext'
import { OrdersProvider } from 'client/contexts/OrdersContext'
import { PixelFactory } from 'pixel-base'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from 'styled-components'

import App from './app/App'
import GlobalStyle from './styles/global'
import { theme } from './styles/theme'
import 'client/index.scss'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)

const AppWithStyles = () => (
  <StrictMode>
    {/* @ts-ignore */}
    <ThemeProvider theme={theme}>
      {/* @ts-ignore */}
      <GlobalStyle />
      <PixelFactory>
        <BrowserRouter>
          <AuthContext>
            <OrdersProvider>
              <MenuProvider>
                <App />
              </MenuProvider>
            </OrdersProvider>
          </AuthContext>
        </BrowserRouter>
      </PixelFactory>
    </ThemeProvider>
  </StrictMode>
)

root.render(<AppWithStyles />)
